import Color from 'color';
export default (function (v) {
  try {
    return Color(v);
  } catch (e) {
    console.error(e);
    return Color();
  }
});